import { Container, Row, Col } from "reactstrap";
import mapIcon from "../../assets/images/icons/maps-and-flags.png";
import { lazy, Suspense } from "react";
import * as userAction from "../../actions/user-action-type";
import cx from "classnames";
import { useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import HomeBanner from "../../components/banners/HomeBanner";
import { useEffect, useState, useRef, useCallback } from "react";
import { useTranslation } from "react-multi-lang";
import ContentLoader from "react-content-loader";
import headBanner from "../../assets/images/headerImages/view-all-destiations-AND-Gallery.jpg";
import desktopBanner from "../../assets/images/ban-desktop-image-1.1f9644e4c43234be0532.jpg";
import mobileBanner from "../../assets/images/ban-mobile-image-1.4b80383a36ec99208fa4.jpg";
import HeaderBanner from "../../components/banners/HeaderBanner";
import "./viewall.scss";
const Modal = lazy(() =>
  import("reactstrap").then((module) => ({ default: module.Modal }))
);


function RenderBookCard(props) {
  const { name, img, id, url_slug, hover_text, index } = props;
  const history = useHistory();
  const t = useTranslation();
  const [isVisible, setIsVisible] = useState(index < 3); // Load first 3 immediately
  const [imageLoaded, setImageLoaded] = useState(false);
  const cardRef = useRef(null);

  // Intersection Observer for lazy loading images below the fold
  useEffect(() => {
    if (index < 3 || isVisible) return; // Skip observer for above-the-fold images

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "50px", // Start loading 50px before visible
        threshold: 0.01,
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, [index, isVisible]);

  const top = () => (
    <div className="top-content">
      <div>
        {name ? (
          <p className="rating">
            <img src={mapIcon} alt="rating" loading="lazy" width="20" height="20" />
            {name}
          </p>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );

  const MouseOver = (event) => {
    if (event.target.querySelector(".dec")) {
      event.target.querySelector(".dec").style.display = "-webkit-box";
    }
  };

  const MouseOut = (event) => {
    if (event.target.querySelector(".dec")) {
      event.target.querySelector(".dec").style.display = "none";
    }
  };

  const bottom = () => {
    const truncateText = (text, maxLines = 5) => {
      if (!text) return "";
      const lines = text.split("\n");
      if (lines.length > maxLines) {
        return lines.slice(0, maxLines).join("\n") + "...";
      }
      return text;
    };

    return (
      <div className="bottom-content">
        <div>
          {localStorage.getItem("user_language") == "en" ? (
            <>
              <p className="title pr-4">{name}</p>
              <p
                className="dec"
                style={{
                  display: "none",
                  WebkitLineClamp: 5,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineClamp: 5,
                }}
              >
                {truncateText(hover_text, 5)}
              </p>
            </>
          ) : (
            <>
              <p className="title pr-4">{name}</p>
              <p
                className="dec"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 5,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineClamp: 5,
                }}
              >
                {truncateText(hover_text, 5)}
              </p>
            </>
          )}
        </div>
      </div>
    );
  };
  // Optimize image URL with CloudFlare Image Resizing for mobile
  const getOptimizedImage = () => {
    const isMobile = window.innerWidth < 768;
    const width = isMobile ? 600 : 800;
    const quality = isMobile ? 80 : 85;
    return `https://bo.discovershurooq.ae/cdn-cgi/image/width=${width},quality=${quality},format=auto/files/${img}`;
  };

  // Placeholder for lazy loading
  const placeholderImage = `https://bo.discovershurooq.ae/cdn-cgi/image/width=50,quality=30,format=auto/files/${img}`;

  return (
    <div
      ref={cardRef}
      className="book-exp-card"
      onClick={() => {
        // Push to dataLayer for GTM tracking
        if (window.dataLayer) {
          window.dataLayer.push({
            event: "package_click",
            package_data: {
              title: name || "",
              price: "0",
              original_price: "0",
              destination: "",
              url_slug: window.location.origin + "/d/" + url_slug,
            },
          });
        }
        history.push(`../d/${url_slug}`);
      }}
      onMouseEnter={MouseOver}
      onMouseLeave={MouseOut}
    >
      {isVisible ? (
        <img
          className="render-image"
          src={getOptimizedImage()}
          alt={name || "Destination"}
          loading={index < 3 ? "eager" : "lazy"}
          decoding="async"
          onLoad={() => setImageLoaded(true)}
          style={{
            opacity: imageLoaded ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
          }}
          width="800"
          height="600"
        />
      ) : (
        <div
          className="render-image-placeholder"
          style={{
            backgroundImage: `url(${placeholderImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            aspectRatio: "4/3",
          }}
        />
      )}
      <div className="content">
        {top()}
        {bottom()}
      </div>
    </div>
  );
}

function ViewAll(props) {
  const [loader, setLoader] = useState(true);
  const t = useTranslation();
  const history = useHistory();
  localStorage.setItem("pathname", history.location.pathname);

  const { destinationData, getDestinationData } = props;
  const [showAd, setShowAd] = useState(false);
  const openAd = useCallback(() => setShowAd(true), []);
  const closeAd = useCallback(() => setShowAd(false), []);
  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });

    const formData = new FormData();
    formData.append("action", "destinations");
    getDestinationData(formData);
  }, []);

  useEffect(() => {
    setTimeout(() => setLoader(false), 2000);
  }, [destinationData]);

  const renderLoader = () => (
    <Row>
      {["", "", "", "", "", ""].map((data, index) => (
        <Col md={4} key={"bookData" + index} className="book-exp-card-col">
          <ContentLoader
            speed={2}
            viewBox="0 0 638 450"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
          >
            <rect x="1" y="0" rx="30" ry="30" width="638" height="380" />
            <rect x="19" y="396" rx="3" ry="3" width="300" height="8" />
            <rect x="19" y="410" rx="3" ry="3" width="300" height="8" />
            <rect x="500" y="410" rx="3" ry="3" width="100" height="8" />
          </ContentLoader>
        </Col>
      ))}
    </Row>
  );

  const renderData = () => (
    <Row>
      {destinationData.length == 0 ? (
        <Col>
          <div style={{ justifyContent: "center", display: "flex" }}>
            <p>No Packages Found</p>
          </div>
        </Col>
      ) : (
        <div></div>
      )}
      {destinationData.map(
        (data, index) =>
          data.hide == "0" &&
          data.enable == "1" && (
            <Col md={4} key={"bookData" + index} className="book-exp-card-col">
              <RenderBookCard {...data} index={index} />
            </Col>
          )
      )}
    </Row>
  );
 
  return (
    <>
      <HeaderBanner 
        backgroundImage={desktopBanner} 
        mobileBackgroundImage={mobileBanner}
        destinationName={' Discover Sharjah\'s Most Loved Destinations'}
         />
        <div
              className="container-fluid py-2 text-light text-center ad"
              style={{ backgroundColor: "black", cursor: "pointer", color: "white" }}
              onClick={openAd}
            >
              <div className="promotion-welcome h3">
                Get 10% off your first order with promo{" "}
                <span className="bg-warning px-2">WELCOME10</span>
              </div>
            </div>
      
            <div
              className="container-fluid py-2 text-light text-center ad d-none"
              style={{
                backgroundColor: "lightblue",
                cursor: "pointer",
                color: "white",
              }}
              onClick={() => history.push("/upload")}
            >
              <div className="promotion-welcome">
                Spend AED 50 and stand a chance to win up to
                <span className="bg-warning px-2" style={{ color: "#eb6139" }}>
                  AED15000
                </span>
              </div>
            </div>
      
            {showAd && (
              <Suspense fallback={<div />}>
                <Modal
                  isOpen={showAd}
                  centered
                  keyboard
                  backdrop={false}
                  size="lg"
                  scrollable={false}
                  toggle={closeAd}
                  onOpened={() => {
                    document.body.style.overflow = "hidden";
                  }}
                  onClosed={() => {
                    document.body.style.overflow = "auto";
                  }}
                >
                  <div
                    className="ad-modal text-center text-uppercase d-flex flex-column align-items-center position-relative"
                    style={{ gap: "15px" }}
                  >
                    <div className="close-icon">
                      <button
                        type="button"
                        className="close"
                        onClick={closeAd}
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <Suspense fallback={<div>Loading...</div>}>
                      <img
                        src={require("../../assets/images/ad-popup.png")}
                        alt="Promotion"
                        className="w-100"
                        loading="lazy"
                      />
                    </Suspense>
                  </div>
                </Modal>
              </Suspense>
            )}
      <section className="book-youre-experience-section">
        <Container fluid="xl">
          <div style={{ textAlign: "center", marginBottom: "50px" }}>
            <h2
              className="sec-title"
              style={{
                fontSize: "2.5rem",
                fontWeight: "bold",
                marginBottom: "20px",
                color: "#000",
              }}
            >
             
            </h2>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#666",
                maxWidth: "900px",
                margin: "0 auto",
                lineHeight: "1.8",
              }}
            >
              Discover the essence of Sharjah through its vibrant waterfronts, cultural charm, and family-friendly attractions. Whether you're seeking relaxation, adventure, or entertainment, each experience reflects the city's perfect blend of tradition and modern leisure.
            </p>
          </div>
          {loader ? renderLoader() : renderData()}
        </Container>
      </section>
    </>
  );
}
const mapStateToProps = ({ user: { destinationData } }) => ({
  destinationData,
});

const mapDispatchToProps = {
  getDestinationData: userAction.getDestinationData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ViewAll));
